// extracted by mini-css-extract-plugin
export default {"parent":"ProfileUser_parent__Egf9S","dropdown":"ProfileUser_dropdown__BwjSo"};